
import { LoadingButton } from '@mui/lab'
import { Box, Button, Dialog, DialogActions, DialogContent, Typography } from '@mui/material'
import { useForm } from 'react-hook-form'
import { toast } from 'react-toastify'

import { Roles } from 'constants/index'
import { GetDriverIdentityRoleDocument, useChangeDriverRoleMutation } from 'generated/graphql'

import { ControlledSelector, ISelectorOption } from '../controller-wrapper'
import { FplDialogTitle } from '../Dialog'

interface SwitchDriverRoleDialogProps {
  driverId: number
  driverRole: string
  openDialog: boolean
  handleCloseDialog: () => any
}

interface FormProps {
  role: string
}

const RoleValues: ISelectorOption[] = [
  { value: Roles.owner, label: Roles.owner },
  { value: Roles.driverSubcontractor, label: Roles.driverSubcontractor },
  { value: Roles.transportController, label: Roles.transportController },
]

const SwitchDriverRoleDialog = (props: SwitchDriverRoleDialogProps) => {
  const { openDialog, driverRole, driverId, handleCloseDialog } = props

  const {
    handleSubmit,
    control,
    formState: { isDirty },
  } = useForm<FormProps>({
    shouldUnregister: true,
    defaultValues: {
      role: driverRole,
    },
  })

  const [changeRole, { loading }] = useChangeDriverRoleMutation({
    onCompleted: (responseData) => {
      if (responseData.changeDriverRole) {
        toast.success('Driver role was successfully updated.')
      } else {
        toast.error('Something went wrong.')
      }

      handleCloseDialog()
    },
    refetchQueries: [{ query: GetDriverIdentityRoleDocument, variables: { driverId } }],
  })

  const onSubmit = (formData: FormProps) => {
    console.warn(formData)
    changeRole({
      variables: {
        input: {
          driverId,
          role: formData.role,
        },
      },
    })
  }

  return (
    <Dialog open={openDialog} color='primary' fullWidth maxWidth='xs'>
      <FplDialogTitle id='form-dialog-title' onClose={handleCloseDialog}>
        <Typography paragraph variant='h5'>
          Change Driver Role
        </Typography>
      </FplDialogTitle>

      <DialogContent>
        <form id='driver-role-form'>
          <Box pt={1}>
            <ControlledSelector
              options={RoleValues}
              name='role'
              label='Role'
              required
              control={control}
            />
          </Box>
        </form>
      </DialogContent>

      <DialogActions>
        <Button variant='contained' color='grey' onClick={handleCloseDialog} disabled={loading}>
          Cancel
        </Button>

        <LoadingButton
          variant='contained'
          form='driver-role-form'
          onClick={handleSubmit(onSubmit)}
          disabled={!isDirty}
          loading={loading}>
          Save
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}

export default SwitchDriverRoleDialog
